import { Component, Injector, Input, OnInit } from '@angular/core';
import {
  TrendDialogBaseComponent
} from "./trend-dialog-base/trend-dialog-base.component";
import { BaseComponentWithDialog } from "../../../base-admin-panel/base-component-with-dialog";
import { TranslateService } from "@ngx-translate/core";
import { ObjectCreateViewModel } from "../../Models/ObjectViewModel";
import { InputViewModel, TrendViewModel } from '../../Models/TrendViewModel';
import { ObjectModel } from "../../../../../models/ObjectModel";
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { AccessRights } from 'app/services/users.service';

@Component({
  selector: 'object-trends-part',
  templateUrl: './object-trends-part.component.html',
  styleUrls: ['./object-trends-part.component.css'],
  standalone: false
})
export class ObjectTrendsPartComponent extends BaseComponentWithDialog implements OnInit {
  @Input()
  public Object: ObjectModel;

  private translate: TranslateService;
  public updated: any;
  Inputs: InputViewModel[] = [];
  canEditTrackers: boolean = false;

  constructor(injector: Injector) {
    super(injector);
    this.translate = injector.get(TranslateService);
    this.canEditTrackers = this.usersService.getCurrentUser().CanDo(AccessRights.EDIT_TRACKERS);
  }

  private GenerateInput() {
    this.Inputs.push(new InputViewModel("-", "---", 0));
    this.Inputs.push(new InputViewModel("PWR", "Power", 0));
    this.Inputs.push(new InputViewModel("BATT", "Battery", 0));
    this.Inputs.push(new InputViewModel("SPEED", "Speed", 0));
    this.Inputs.push(new InputViewModel("ALT", "Altitude", 0));
    this.Inputs.push(new InputViewModel("HDOP", "HDOP", 0));
    this.Inputs.push(new InputViewModel("DIR", "Direction", 0));
    this.Inputs.push(new InputViewModel("SAT", "Satellites", 0));

    this.Inputs.push(new InputViewModel("ALARM", "Alarm button", 0));
    this.Inputs.push(new InputViewModel("GSMSS", "GSM signal", 0));
    this.Inputs.push(new InputViewModel("GSM_OPERATOR", "GSM Operator", 0));

    this.Inputs.push(new InputViewModel("EKEY", "Key code", 0));
    this.Inputs.push(new InputViewModel("ODO", "Odometer", 0));
    this.Inputs.push(new InputViewModel("STATUS", "Status", 0));
    this.Inputs.push(new InputViewModel("ORDER", "Order ID", 0));

    this.Inputs.push(new InputViewModel("FUEL", "Fuel", 9));
    this.Inputs.push(new InputViewModel("ACCEL", "X acceleration", 0));
    this.Inputs.push(new InputViewModel("BREAK_ACCEL", "Breaking", 0));
    this.Inputs.push(new InputViewModel("TURN_ACCEL", "Y acceleration", 0));
    this.Inputs.push(new InputViewModel("VACCEL", "Z acceleration", 0));

    this.Inputs.push(new InputViewModel("AIN", "Analog input", 32));
    this.Inputs.push(new InputViewModel("BLUE", "Bluetooth", 256));
    this.Inputs.push(new InputViewModel("COUNT", "Counter", 16));
    this.Inputs.push(new InputViewModel("DIN", "Discrete input", 16));
    this.Inputs.push(new InputViewModel("DINSET", "Discrete input set", 0));
    this.Inputs.push(new InputViewModel("DOUT", "Discrete output", 16));

    this.Inputs.push(new InputViewModel("CAN", "Canbus", 256));
    this.Inputs.push(new InputViewModel("MODBUS", "Modbus", 256));
    this.Inputs.push(new InputViewModel("TEMP", "Temperature", 8));
    this.Inputs.push(new InputViewModel("TEMPINT", "Internal temperature", 0));

    this.Inputs.push(new InputViewModel("IN", "Input", 4096));
  }


  ngOnInit(): void {
    super.ngOnInit();
    this.GenerateInput();
  }

  public openAdd() {
    this.prepareModal(TrendDialogBaseComponent);
    this.componentRef.instance.Id = this.Object.Id;
    this.componentRef.instance.Inputs = this.Inputs;
    this.componentRef.instance.open(new TrendViewModel());
    this.componentRef.instance.onSubmit.subscribe(() => {
      let trend = this.componentRef.instance.model;
      trend.TrackerId = this.Object.Id;
      this.updated = new Date();
      this.Object.Sensors.push(trend);
    });
  }

  public getSensorDisplay(sensorType: string) {
    let res = sensorType.replace("POINTBYEVT", "")
      .replace("HIDDENINFO", "")
      .replace("NORMSEVENT", "")
      .replace("NODISPATCH", "")
      .replace(/  /g, " ").trim();
    if (res.length > 0)
      return this.translate.instant(res);
    return "";
  }

  public getInputName(input: TrendViewModel) {
    let inputNumber = 0;
    let res = input.Source;
    let matches = res.match(/\d+$/);
    if (matches) {
      inputNumber = parseInt(matches[0], 10);
      res = res.replace(matches[0], "")
    }
    let foundInput = this.Inputs.find(i => i.Id == res);
    if (!foundInput)
      return input.Source;
    if (foundInput.AvailableNumbers > 0)
      return this.translate.instant(foundInput.Name) + " " + inputNumber;
    return this.translate.instant(foundInput.Name);
  }

  public openEdit(trend: TrendViewModel) {
    let copy = Object.assign({}, trend);
    this.prepareModal(TrendDialogBaseComponent);
    this.componentRef.instance.onClose.subscribe(() => {
      let t = this.Object.Sensors.find(t => t.Id == trend.Id);
      if (t) {
        let idx = this.Object.Sensors.indexOf(t);
        this.Object.Sensors[idx] = copy;
      }
    });
    this.componentRef.instance.Id = this.Object.Id;
    this.componentRef.instance.Inputs = this.Inputs;
    this.componentRef.instance.open(trend);
  }

  public deleteTrend(trend: TrendViewModel) {
    let message = this.translate.instant("Delete");
    if (!confirm(message + " " + trend.Name + "?")) return;
    let idx = this.Object.Sensors.indexOf(trend);
    if (idx < 0) return;
    this.Object.Sensors.splice(idx, 1);
  }

  drop(event: CdkDragDrop<TrendViewModel[]>) {
    if (event.previousIndex === event.currentIndex) return;

    moveItemInArray(this.Object.Sensors, event.previousIndex, event.currentIndex);
    this.updateOrderNumbers();
  }

  updateOrderNumbers() {
    this.Object.Sensors.forEach((t, index) => {
      t.OrderNumber = index + 1;
    });
  }
}
